import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  base: '/shop',
  mode: 'history',
  routes: [{
      path: '/',
      redirect: '/index'
    }, {
      path: '/detail/:id',
      name: 'detail',
      component: () => import('./views/detail/detail.vue')
    },
    {
      path: '/spread/:spreadCode',
      name: 'spreadCode',
      component: () => import('./views/spread/index.vue')
    },
    {
      path: '/index',
      name: 'index',
      component: () => import('./views/index/index.vue')
    },
    {
      path: '/createPackorder/:id/:groupId/:studentId',
      name: 'createPackorder',
      component: () => import('./views/createPackorder/createPackorder.vue')
    },
    {
      path: '/order/list',
      name: 'orderList',
      component: () => import('./views/order/list/index.vue')
    },
    {
      path: '/order/pay/:payOrderId/:orderType/:studentId',
      name: 'orderPay',
      component: () => import('./views/order/pay/index.vue')
    },
    {
      path: '/order/internationalPay/:payOrderId/:orderType/:studentId',
      name: 'InternationalPay',
      component: () => import('@/views/order/pay/internationalPay.vue')
    },
    {
      path: '/order/payResult',
      name: 'payResult',
      component: () => import('./views/order/payResult/index.vue')
    },
    {
      path: '/error/404',
      name: 'error404',
      component: () => import('./views/error/404.vue')
    },
    {
      path: '/error/500',
      name: 'error500',
      component: () => import('./views/error/500.vue')
    }
  ]
})